import styled from "styled-components";

const Spinner = styled.div`
  width: 30px;
  height: 30px;
  border: 5px solid #eee;
  border-radius: 50%;
  border-top-color: #ff6a00;

  /* Spin loader */
  animation: spin 0.5s linear infinite;

  /* spin animation declared */
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/Spinner/index.js